import type { ParamsType } from "../../types";

const PII_ANSWER = [
  "customer_title",
  "customer_first_name",
  "customer_last_name",
  "customer_email_address",
  "preapp_email_address",
  "customer_telephone_number",
  "customer_alternative_telephone_number",
  "uk_address_lookup",
  "uk_correspondence_address_lookup",
  "customer_address_1_pre_quote",
  "customer_address_2_pre_quote",
  "customer_town_pre_quote",
  "customer_postcode_pre_quote",
  "customer_address_1",
  "customer_address_2",
  "customer_town",
  "customer_postcode",
  "address_1_pre_quote",
  "address_2_pre_quote",
  "uk_postcode_pre_quote",
  "town_pre_quote",
  "owner_first_name",
  "owner_last_name",
  "beneficiary_first_name",
  "beneficiary_last_name",
  "gender",
  "dynamic_ssn_fein",
  "ssn",
  "fein",
  "sof_county_court_judgement_online_yes",
  "sof_county_court_judgement_online_no",
  "sof_ccj_count",
  "sof_ccj_value",
  "sof_ccj_date",
  "sof_court_judgement_yes",
  "sof_court_judgement_no",
  "ccj_date",
  "sof_single_ccj_no",
  "sof_single_ccj_yes",
  "sof_ccj_yes",
  "sof_ccj_no",
  "ccj_count",
  "sof_bankrupt_yes",
  "sof_bankrupt_no",
  "sof_multiple_bankruptcies_yes",
  "sof_multiple_bankruptcies_no",
  "bankruptcy_date",
  "sof_single_bankruptcy_no",
  "sof_single_bankruptcy_yes",
  "sof_bankruptcy_yes",
  "sof_bankruptcy_no",
  "bankruptcy_discharged",
  "sof_liquidation_yes",
  "sof_liquidation_no",
  "sof_multiple_liquidations",
  "liquidation_date",
  "sof_criminal_offence_yes",
  "sof_criminal_offence_no",
  "sof_criminal_yes",
  "sof_criminal_no",
  "hcp_date_of_birth_1",
  "hcp_date_of_birth_2",
  "hcp_date_of_birth_3",
  "hcp_date_of_birth_4",
  "hcp_date_of_birth_5",
  "hcp_date_of_birth_6",
  "hcp_date_of_birth_7",
  "hcp_date_of_birth_8",
  "hcp_date_of_birth_9",
  "hcp_date_of_birth_10",
  "sof_previous_claims_yes",
  "sof_previous_claims_no",
  "sof_claims_yes",
  "sof_claims_no",
  "sof_property_claims_in_the_last_5_years_yes",
  "sof_property_claims_in_the_last_5_years_no",
  "sof_property_claims_in_the_last_0_to_4_years_yes",
  "sof_property_claims_in_the_last_0_to_4_years_no",
  "claim_count",
  "sof_number_of_claims",
  "number_of_claims_in_last_5_years",
  "number_of_claims_in_time_owned",
  "date_of_incident_1",
  "date_of_incident_2",
  "date_of_incident_3",
  "date_of_incident_4",
  "date_of_incident_5",
  "type_of_incident_1",
  "type_of_incident_2",
  "type_of_incident_3",
  "type_of_incident_4",
  "type_of_incident_5",
  "incident_value_1",
  "incident_value_2",
  "incident_value_3",
  "incident_value_4",
  "incident_value_5",
  "sof_pollution_disease_claims_yes",
  "sof_pollution_disease_claims_no",
  "sof_potential_claims_yes",
  "sof_potential_claims_no",
  "sof_previous_circumstances_yes",
  "sof_previous_circumstances_no",
  "sof_possible_claims_yes",
  "sof_possible_claims_no",
  "date_of_possible_incident",
  "type_of_possible_incident",
  "possible_incident_value",
  "sof_property_claims_yes",
  "sof_property_claims_no",
  "sof_liability_claims_yes",
  "sof_liability_claims_no",
  "van_registration",
  "sof_disqualified_director_yes",
  "sof_disqualified_director_no",
  "sof_insurance_refused_yes",
  "sof_insurance_refused_no",
  "sof_insurance_declined_yes",
  "sof_insurance_declined_no",
  "insurance_refused",
];

const RADIO_ANSWER_FROM_QUESTIONS = [
  "have_secondary_trade_yes",
  "have_secondary_trade_no",
];

const ANSWER_SUFFIX_PATTERN = /_(yes|no)$/;

export const redact = (params: ParamsType) => {
  let { question, answer } = params;

  const piiAnswer = new Set(PII_ANSWER);
  const radioAnswerFromQuestions = new Set(RADIO_ANSWER_FROM_QUESTIONS);

  if (piiAnswer.has(question)) {
    answer = "REDACTED";
    question = question?.replace(ANSWER_SUFFIX_PATTERN, "");
  } else if (radioAnswerFromQuestions.has(question)) {
    question = question?.replace(ANSWER_SUFFIX_PATTERN, "");
  }
  return { question, answer };
};
